(() => {
  // Gating de logs verbosos. Reativar com: localStorage.pacco_debug='1' (recarregar).
  const __dbg = (typeof window !== 'undefined') && (window.PACCO_DEBUG || (function(){ try { return localStorage.getItem('pacco_debug') === '1'; } catch(_) { return false; } })());
  const log = __dbg ? console.log.bind(console, '[Helper Chat]') : function(){};
  const CUSTOM_LAUNCHER_SELECTOR = '.chat-js';
  const REVEAL_THRESHOLD = 10;
  let zendeskLoaderPromise = null;

  // URL do script Zendesk (será pego do data-zendesk-url ou hardcoded)
  let zendeskScriptUrl = '';

  window.zESettings = window.zESettings || {
    webWidget: {
      launcher: {
        customLauncherSelector: CUSTOM_LAUNCHER_SELECTOR,
      },
    },
  };

  function hideZendeskDefault() {
    try {
      if (typeof window.zE === 'function') {
        window.zE('messenger:on', 'booted', () => window.zE('messenger', 'hide'));
      }
    } catch (error) {
      console.warn('[Zendesk] Unable to hide default widget.', error);
    }
  }

  function ensureZendeskLoaded(url) {
    log('ensureZendeskLoaded called:', { url, zendeskScriptUrl, hasPromise: !!zendeskLoaderPromise });
    
    if (zendeskLoaderPromise) return zendeskLoaderPromise;
    const scriptUrl = url || zendeskScriptUrl;
    if (!scriptUrl) {
      console.warn('[Helper Chat] No Zendesk URL available!');
      return Promise.resolve();
    }

    log('Loading Zendesk script from:', scriptUrl);
    
    zendeskLoaderPromise = new Promise((resolve) => {
      const script = document.createElement('script');
      script.id = 'ze-snippet';
      script.src = scriptUrl;
      script.async = true;
      script.onload = () => {
        log('Zendesk script loaded successfully');
        hideZendeskDefault();
        resolve();
      };
      script.onerror = (error) => {
        console.warn('[Zendesk] Failed to load messenger.', error);
        resolve();
      };
      document.head.appendChild(script);
    });

    return zendeskLoaderPromise;
  }

  function updatePosition(helper) {
    const isMobile = window.matchMedia('(max-width:767px)').matches;
    helper.style.left = isMobile ? '16px' : '20px';
    helper.style.right = 'auto';
    helper.style.removeProperty('bottom');
  }

  function updateVisibility(helper, menu, button) {
    if (window.scrollY > REVEAL_THRESHOLD) {
      helper.classList.add('visible');
    } else {
      helper.classList.remove('visible');
      if (menu) menu.classList.remove('visible');
      if (button) button.innerHTML = '<span>ajuda?</span>';
    }
  }

  function openZendeskMessenger(url) {
    log('Opening Zendesk...', { url, zendeskScriptUrl, hasZE: typeof window.zE });
    
    const attemptOpen = () => {
      log('attemptOpen called, zE type:', typeof window.zE);
      try {
        if (typeof window.zE === 'function') {
          log('Calling zE messenger show/open');
          window.zE('messenger', 'show');
          window.zE('messenger', 'open');
          return;
        }
      } catch (error) {
        console.warn('[Zendesk] Messenger open failed, retrying.', error);
      }
      setTimeout(attemptOpen, 500);
    };

    ensureZendeskLoaded(url).then(() => {
      log('Zendesk loaded, attempting to open');
      attemptOpen();
    });
  }

  // Expõe função global para abrir chat (usado no mobile)
  window.openPaccoChat = function() {
    openZendeskMessenger(zendeskScriptUrl);
  };

  // Handler global para elementos com data-action="script"
  function setupScriptActions() {
    document.addEventListener('click', (e) => {
      const el = e.target.closest('[data-action="script"]');
      if (!el) return;
      
      log('Script action clicked:', el);
      e.preventDefault();
      e.stopPropagation();
      
      const script = el.getAttribute('data-script');
      log('Script to execute:', script);
      
      if (script && script.includes('zE(')) {
        // É um comando Zendesk - usa nossa função
        log('Detected Zendesk command, opening messenger');
        openZendeskMessenger(zendeskScriptUrl);
      } else if (script) {
        // Outro script - executa diretamente
        try { new Function(script)(); } catch(err) { console.warn('[Script Action]', err); }
      }
    });
  }

  // Setup global dos botões .chat-js (funciona em QUALQUER viewport)
  function setupGlobalChatButtons() {
    document.addEventListener('click', (e) => {
      const chatEl = e.target.closest(CUSTOM_LAUNCHER_SELECTOR);
      if (!chatEl) return;
      e.preventDefault();
      openZendeskMessenger(zendeskScriptUrl);
    });
  }

  function init() {
    // Pega URL do Zendesk de QUALQUER elemento que tenha (helper ou qualquer outro)
    const helper = document.getElementById('helper-chat');
    if (helper && helper.dataset.zendeskUrl) {
      zendeskScriptUrl = helper.dataset.zendeskUrl;
    }
    
    // Fallback: procura qualquer script com zendesk-snippet
    if (!zendeskScriptUrl) {
      const scripts = document.querySelectorAll('script[src*="zendesk-snippet"]');
      if (scripts.length > 0) {
        zendeskScriptUrl = scripts[0].src;
      }
    }
    
    // Console para debug
    log('Zendesk URL:', zendeskScriptUrl);

    // Configura handlers globais (funcionam em mobile e desktop)
    setupScriptActions();
    setupGlobalChatButtons();

    if (!helper) return;

    const button = helper.querySelector('.helper-chat__bt.help');
    const menu = document.getElementById('helper-menu');
    const chatLink = helper.querySelector(CUSTOM_LAUNCHER_SELECTOR);

    updatePosition(helper);
    updateVisibility(helper, menu, button);

    window.addEventListener('resize', () => updatePosition(helper));
    window.addEventListener('scroll', () => updateVisibility(helper, menu, button), { passive: true });

    if (button && menu) {
      button.addEventListener('click', () => {
        const opened = menu.classList.toggle('visible');
        button.innerHTML = opened ? '<span>X</span>' : '<span>ajuda?</span>';
        if (opened) {
          ensureZendeskLoaded(zendeskScriptUrl);
        }
      });
    }

    if (chatLink) {
      chatLink.addEventListener('click', (event) => {
        event.preventDefault();
        menu?.classList.remove('visible');
        openZendeskMessenger(zendeskScriptUrl);
      });
      chatLink.addEventListener('mouseenter', () => ensureZendeskLoaded(zendeskScriptUrl), { once: true });
      chatLink.addEventListener('focus', () => ensureZendeskLoaded(zendeskScriptUrl), { once: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
